import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Nameless',
    name: 'Lord des Verderbens',
    id: 'BlightLord',
    health: 70,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'Nameless',
    name: 'Der Wegbereiter',
    id: 'WaywardOne',
    health: 60,
    difficulty: 7,
    expeditionRating: 3,
    additionalInfo: '',
  },
]
